import { LayoutGrid } from 'lucide-react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip';

interface MultiViewToggleProps {
  isEnabled: boolean;
  onToggle: (value: boolean) => void;
}

export function MultiViewToggle({ isEnabled, onToggle }: MultiViewToggleProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => onToggle(!isEnabled)}
            className={`flex h-7 w-7 items-center justify-center rounded transition-opacity hover:opacity-100 ${
              isEnabled ? 'opacity-100' : 'opacity-30'
            }`}
            aria-label="Toggle Multi View"
          >
            <LayoutGrid className="h-4 w-4 text-foreground" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="border-border bg-background text-foreground"
        >
          <p>Multi View</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
